
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display: inline-flex;
  border-radius: 0.5rem;
  vertical-align: middle;
}

.btn {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  border-radius: 0.5rem;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  font-weight: var(--fw-semibold);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
  line-height: 1.5 !important;
  padding:0.5em 1em;
}

.btn idb-icon{
    font-size:1.25em;
  }

.btn idb-icon.left{
      margin-right:0.5em;
    }

.btn idb-icon.right{
      margin-left:0.5em;
    }

.btn.btn-icon{
    padding:0.625em;
  }

.btn.btn-icon idb-icon.left, .btn.btn-icon idb-icon.right {
  margin: 0px;
}

.btn[aria-disabled='true'] {
  pointer-events: none !important;
  cursor: not-allowed !important;
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}

.grid-button{
  text-align:center;
  width:100%;
  display:table-cell;
  vertical-align:middle;
}

.grid-button-wrapper{
  height:100%;
  text-align:center;
  width:100%;
  display:table-cell;
  vertical-align:middle;
}

.btn.primary {
  border-style: none;
  background-color: var(--blue-responsible-main);
  color: var(--neutral-white);
}

.btn.primary:hover, .btn.primary:focus, .btn.primary.active {
  background-color: var(--blue-responsible-darken-2);
}

.btn.primary:hover, .btn.primary:focus, .btn.primary.active {
  color: var(--neutral-white);
}

.primary[aria-disabled='true'] {
  background-color: var(--gray-cosmopolitan-lighten-2) !important;
  color: var(--neutral-white) !important;
}

.btn.secondary {
  background-color: var(--neutral-white);
  color: var(--blue-responsible-main);
  border:1px solid var(--blue-responsible-main);
}

.btn.secondary:hover, .btn.secondary:focus, .btn.secondary.active, .btn.secondary[aria-current='page'] {
  background-color: var(--blue-responsible-main);
}

.btn.secondary:hover, .btn.secondary:focus, .btn.secondary.active, .btn.secondary[aria-current='page'] {
  color: var(--neutral-white);
}

.secondary[aria-disabled='true'] {
  background-color: var(--gray-cosmopolitan-lighten-5) !important;
  color: var(--gray-professional-lighten-2) !important;
  border:1px solid var(--gray-professional-lighten-2);
}

.btn.small {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

.btn.medium {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

.btn.large {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

.btn.none {
  border-width: 0px !important;
  background-color: var(--neutral-transparent) !important;
  font-family: Open Sans, Helvetica, Arial, sans-serif !important;
  font-size: var(--fs-base) !important;
  line-height: var(--lh-base) !important;
  font-weight: var(--fw-medium) !important;
  color: var(--blue-responsible-darken-2) !important;
}

.btn.none:hover, .btn.none:focus {
  color: var(--blue-responsible-main) !important;
}

.btn.none:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.btn.none:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.btn.none:focus {
  --tw-ring-color: var(--blue-responsible-main) !important;
}

.btn.none[aria-disabled='true'] {
  color: var(--gray-professional-lighten-2) !important;
}

.btn.none[aria-disabled='true'] {
  -webkit-text-decoration-line: none !important;
          text-decoration-line: none !important;
}

.btn.none[aria-disabled='true']:focus {
  color: var(--gray-professional-main) !important;
}

:focus {
  outline-offset: 2px;
  outline-width: 3px;
  outline-style: solid;
  outline-color: #4299e1;
}

:host(.prev-next) a:hover, :host(.prev-next) a:focus, :host(.prev-next) a.active {
  cursor: pointer !important;
}

:host(.prev-next) a:hover, :host(.prev-next) a:focus, :host(.prev-next) a.active {
  color: var(--green-guarantee-lighten-1) !important;
}

:host(.prev-next) a:hover, :host(.prev-next) a:focus, :host(.prev-next) a.active {
  -webkit-text-decoration-line: underline !important;
          text-decoration-line: underline !important;
}
`;